import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alpha',
  templateUrl: './alpha.component.html',
  styleUrls: ['./alpha.component.scss']
})
export class AlphaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
